import TruststoreTable from './TruststoreTable';

export default TruststoreTable;
